export interface PostHogConfig {
  apiHost: string;
  uiHost: string;
  key: string;
  useReverseProxy: boolean;
  fallbackToDirect: boolean;
}

export const getPostHogConfig = (): PostHogConfig => {
  // const isClient = typeof window !== 'undefined';

  // if (!isClient) {
  //   return {
  //     apiHost: '',
  //     uiHost: '',
  //     key: '',
  //     useReverseProxy: false,
  //     fallbackToDirect: false,
  //   };
  // }

  const env = (window as any).ENV;
  const posthogKey = env?.POSTHOG_KEY || '';
  const originalHost = env?.POSTHOG_HOST || '';

  /*
   * Determine if we should use reverse proxy
   * You can control this via environment variable or feature flag
   * If POSTHOG_USE_PROXY is explicitly "false", don't use proxy
   * If it's "true" or undefined, use proxy (default behavior)
   */
  const useReverseProxy = env?.POSTHOG_USE_PROXY !== 'false';

  let apiHost: string;
  let uiHost: string;

  if (useReverseProxy) {
    // Use reverse proxy for better tracking
    apiHost = `${window.location.origin}/api/posthog`;
    uiHost = originalHost.replace('i.posthog.com', 'posthog.com');
  } else {
    // Use direct PostHog connection
    apiHost = `https://${originalHost}`;
    uiHost = originalHost.replace('i.posthog.com', 'posthog.com');
  }

  console.log('[PostHog Config] ===== PostHog Configuration =====');
  console.log('[PostHog Config] POSTHOG_USE_PROXY env var:', env?.POSTHOG_USE_PROXY);
  console.log('[PostHog Config] useReverseProxy decision:', useReverseProxy);
  console.log('[PostHog Config] apiHost:', apiHost);
  console.log('[PostHog Config] uiHost:', uiHost);
  console.log('[PostHog Config] posthogKey:', posthogKey ? 'Set' : 'Missing');
  console.log('[PostHog Config] originalHost:', originalHost);
  console.log('[PostHog Config] =====================================');

  return {
    apiHost,
    uiHost,
    key: posthogKey,
    useReverseProxy,
    fallbackToDirect: false,
  };
};

export const getPostHogInitConfig = () => {
  const config = getPostHogConfig();

  return {
    api_host: config.apiHost,
    ui_host: config.uiHost,
    loaded: (posthog: any) => {
      // Enable debug mode in development
      if (process.env.NODE_ENV === 'development') {
        posthog.debug();
      }
    },
    // Additional configuration options
    capture_pageview: true,
    capture_pageleave: true,
    disable_session_recording: false,
    enable_recording_console_log: process.env.NODE_ENV === 'development',
    enable_recording_network_payloads: false,
    respect_dnt: true, // Respect Do Not Track
  };
};

// Function to get fallback configuration when proxy fails

export const getPostHogFallbackConfig = () => {
  const env = (window as any).ENV;
  const posthogKey = env?.POSTHOG_KEY || '';
  const originalHost = env?.POSTHOG_HOST || '';

  return {
    api_host: `https://${originalHost}`,
    ui_host: originalHost.replace('i.posthog.com', 'posthog.com'),
    loaded: (posthog: any) => {
      if (process.env.NODE_ENV === 'development') {
        posthog.debug();
      }

      console.log('[PostHog] Fallback to direct connection activated');
    },
    capture_pageview: true,
    capture_pageleave: true,
    disable_session_recording: false,
    enable_recording_console_log: process.env.NODE_ENV === 'development',
    enable_recording_network_payloads: false,
    respect_dnt: true,
  };
};
